import React, { useEffect, useState } from 'react';
import { Button, Grid, Stack, SvgIcon, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { paths } from 'src/paths';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getAllMdsFormAction, signMdsFormAction } from 'src/redux/actions/mdsCommunicationActions';
import loader from 'src/components/LoaderImg/loader.gif';
import { Box } from '@mui/system';
import { getSignatureTemplateUrl } from 'src/utils/jotform-functions';

function SignMdsCommunication() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { patients, patientDetails, mdsCommunication } = paths;
  const { patientId, patientData, mdsData } = location.state;
  const getMdsSignatureTemplate = useSelector((state: any) => state.signMdsFormReducer);

  const callGetMdsList = (status?: string | null) => {
    dispatch(
      getAllMdsFormAction(patientId, {
        status,
        sortBy: 'assessmentDate',
        sortDirection: 'desc',
        page: 0,
        pageSize: 10,
      })
    );
  };

  const gotoback = () => {
    callGetMdsList();
    navigate(`${patients}/${patientDetails}${mdsCommunication}`, {
      state: {
        patientId,
        patientData,
      },
    });
  };

  useEffect(() => {
    dispatch(signMdsFormAction(mdsData.uuid));
  }, []);

  return (
    <>
      <Grid
        container
        justifyContent={'space-between'}
      >
        <Stack
          gap="1.5rem"
          sx={{ padding: '0 4rem' }}
        >
          <Button
            sx={{
              justifyContent: 'flex-start',
              color: '#111927',
              width: 'max-content',
              padding: '0px',
            }}
            onClick={gotoback}
            startIcon={
              <SvgIcon>
                <ArrowBackIcon sx={{ color: '#6C737F' }} />
              </SvgIcon>
            }
          >
            <Typography variant="subtitle1">Back to MDS Assessment List</Typography>
          </Button>
          <Stack
            flexDirection="row"
            gap="1rem"
            alignItems="center"
          >
            <Typography variant="h5">Sign Document - MDS Assessment</Typography>
          </Stack>
        </Stack>
      </Grid>

      {getMdsSignatureTemplate?.loading ? (
        <img
          src={loader}
          alt="loader"
          style={{ width: '10%', margin: 'auto' }}
        />
      ) : (
        <Box
          sx={{ height: '100%' }}
          p={3}
        >
          <iframe
            src={getSignatureTemplateUrl({
              documentId: getMdsSignatureTemplate.response?.data?.data?.documentId,
              embedKey: getMdsSignatureTemplate.response?.data?.data?.embedKey,
            })}
            width={'100%'}
            height={'100%'}
            title=""
            style={{ border: 'none' }}
          />
        </Box>
      )}
    </>
  );
}

export default SignMdsCommunication;
